import {
  FETCH_PAGINATED_PRODUCT_TAGS,
  FETCH_ALL_PRODUCT_TAGS,
  RESET_PRODUCT_TAGS,
} from './../../mutation-types';

export default {
  [FETCH_PAGINATED_PRODUCT_TAGS](state, { productTags, pagination }) {
    state.items = productTags;
    state.pagination = pagination;
  },

  [FETCH_ALL_PRODUCT_TAGS](state, productTags) {
    state.all = productTags;
  },

  [RESET_PRODUCT_TAGS](state) {
    state.all = [];
    state.items = [];
    state.pagination = {};
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/productTag/mutations.js